import React from 'react';
import { Checkbox } from 'antd';
import { FeaturesGrid, FeatureItem } from './styles';
import { withTranslation } from 'react-i18next';
import { FEATURES } from './translationValues';

export const AVAILABLE_FEATURES = [
  { name: 'Dashboard', description: 'Access dashboard and analytics', isEnabled: true },
  { name: 'Design System', description: 'Access and manage design system components', isEnabled: true },
  { name: 'Transactions', description: 'View and process transactions', isEnabled: true },
  { name: 'Admin Configurations', description: 'Configure administrative settings', isEnabled: true },
  { name: 'Hybrid Mail Room', description: 'Smart addressing for automated mail delivery', isEnabled: true },
  { name: 'Mail Room', description: 'Manage documents for printing', isEnabled: true },
  { name: 'Account Details', description: 'View and manage account information', isEnabled: true },
  { name: 'Manage Business Data', description: 'Create and manage data variables and business contracts', isEnabled: true },
  { name: 'Cleanup Storage', description: 'Clean up and manage storage space', isEnabled: true },
  { name: 'Workflow', description: 'Create, import and manage workflow', isEnabled: true }
];

const NAMESPACES = [];

function FeaturesSelector({ t, features = [], isDisabled = false, onChange }) {
  const handleFeatureChange = (featureName, checked) => {
    const updatedFeatures = features.map(feature => 
      feature.name === featureName 
        ? { ...feature, isEnabled: checked }
        : feature
    );
    onChange(updatedFeatures);
  };

  const handleSelectAll = (e) => {
    const updatedFeatures = features.map(feature => ({
      ...feature,
      isEnabled: e.target.checked
    }));
    onChange(updatedFeatures);
  };

  const enabledCount = features.filter(f => f.isEnabled).length;
  const allSelected = enabledCount === features.length;
  const someSelected = enabledCount > 0 && enabledCount < features.length;

  return (
    <div>
      <div style={{ marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', pointerEvents : isDisabled ? 'none' : 'auto' }}>
        <Checkbox
          checked={allSelected}
          indeterminate={someSelected}
          onChange={handleSelectAll}
          style={{ fontWeight: 600, fontSize: '0.875rem' }}
        >
          {t(FEATURES.SELECT_ALL_FEATURES.key, FEATURES.SELECT_ALL_FEATURES.value)} ({enabledCount}/{features.length})
        </Checkbox>
      </div>
      
      <FeaturesGrid style={{pointerEvents : isDisabled ? 'none' : 'auto'}}>
        {features.map(feature => (
          <FeatureItem key={feature.name}>
            <Checkbox
              checked={feature.isEnabled}
              onChange={(e) => handleFeatureChange(feature.name, e.target.checked)}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.875rem', color: '#111827' }}>
                  {feature.name}
                </div>
                <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '2px' }}>
                  {feature.description}
                </div>
              </div>
            </Checkbox>
          </FeatureItem>
        ))}
      </FeaturesGrid>
    </div>
  );
}

export default withTranslation(NAMESPACES)(FeaturesSelector);
